document.addEventListener('DOMContentLoaded', () => {
  const animationClassNames = [
    'slide-up',
    'slide-down',
    'slide-left',
    'slide-right',
    'fade-in',
    'slide-in-media-text',
    'slide-in-media-text-vertical',
  ];

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Observer for smaller screens, triggers when any part of the element is visible
  // Observer for smaller screens, triggers when the target is within 100px of entering the viewport
  const observerSmallScreen = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const targetClassList = Array.from(entry.target.classList);

          targetClassList.forEach((className) => {
            if (animationClassNames.includes(className)) {
              entry.target.classList.add(`${className}-played`);
            }
          });
        }
      });
    },
    {
      rootMargin: '0px 0px 100px 0px',
      threshold: 0,
    }
  );

  // Observer for larger screens, triggers when the element is fully visible
  const observerLargeScreen = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.75) {
          const targetClassList = Array.from(entry.target.classList);

          targetClassList.forEach((className) => {
            if (animationClassNames.includes(className)) {
              // Add '-played' suffix to the animation class name before adding it
              entry.target.classList.add(`${className}-played`);
            }
          });
        }
      });
    },
    {
      rootMargin: '0px 0px 100px 0px',
      threshold: 0.75,
    }
  );

  // Generate a selector string to select elements with classes from the array
  const selector = animationClassNames
    .map((className) => `.${className}`)
    .join(', ');

  // Get elements in the document that match the class names in the array
  const elements = document.querySelectorAll(selector);

  let currentObserver =
    window.innerWidth >= 768 ? observerLargeScreen : observerSmallScreen;

  // Initial observation based on viewport width
  elements.forEach((el) => {
    currentObserver.observe(el);
  });

  const handleResize = debounce(() => {
    // Unobserve all elements with the old observer
    elements.forEach((el) => {
      currentObserver.unobserve(el);
    });

    // Choose the appropriate observer based on the new viewport width
    currentObserver =
      window.innerWidth >= 768 ? observerLargeScreen : observerSmallScreen;

    // Reobserve all elements with the new observer
    elements.forEach((el) => {
      currentObserver.observe(el);
    });
  }, 200); // Debounce time

  window.addEventListener('resize', handleResize);
});
